import React, { useState, FormEvent } from "react";
import { toast } from "react-hot-toast";
import contactService from "@/service/contactService";
import Footer from "@/components/landing/contact/Footer";
import Header from "@/components/landing/contact/Header";

interface FormData {
  name: string;
  email: string;
  phone: string;
  topic: string;
  message: string;
}

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: "",
    email: "",
    phone: "",
    topic: "Protega Product Protection",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  // Honeypot: hidden from people, but form-filling bots tend to fill it in.
  const [website, setWebsite] = useState("");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    // Basic validation before submission
    if (!formData.name || !formData.email || !formData.phone || !formData.message) {
      toast.error("Please fill out all required fields.");
      return;
    }

    setLoading(true);
    try {
      await contactService({ ...formData, website });
      toast.success("Message sent successfully! We'll get back to you soon.");
      setFormData({
        name: "",
        email: "",
        phone: "",
        topic: "Protega Product Protection",
        message: "",
      });
    } catch (error) {
      toast.error("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <main className="md:tw-w-2/5 tw-px-5 tw-my-20 tw-mx-auto tw-h-vh">
        <h1 data-aos="fade-up" className="tw-text-5xl tw-my-5 tw-text-center tw-font-thin">
          Contact Us
        </h1>
        <p data-aos="fade-up" className="tw-text-2xl tw-mb-20">
          Hey there! <br />
          Questions on your protection plans – we are here to help! Please fill out the form.
        </p>

        <form onSubmit={handleSubmit}>
          <div aria-hidden="true" style={{ position: "absolute", left: "-10000px", width: 1, height: 1, overflow: "hidden" }}>
            <label htmlFor="website">Website</label>
            <input
              type="text"
              id="website"
              name="website"
              tabIndex={-1}
              autoComplete="off"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />
          </div>

          <div data-aos="fade-up">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter Name"
              className="tw-p-2 tw-bg-[#202020] tw-mt-2 tw-mb-6 tw-w-full tw-rounded-md"
              required
            />
          </div>

          <div data-aos="fade-up">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email Id"
              className="tw-p-2 tw-bg-[#202020] tw-mt-2 tw-mb-6 tw-w-full tw-rounded-md"
              required
            />
          </div>

          <div data-aos="fade-up">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="text"
              id="phone"
              inputMode="numeric"
              pattern="[0-9]*"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Number"
              className="tw-p-2 tw-bg-[#202020] tw-mt-2 tw-mb-6 tw-w-full tw-rounded-md"
              required
            />
          </div>

          <div data-aos="fade-up">
            <label htmlFor="topic">Support Topic</label>
            <select
              id="topic"
              value={formData.topic}
              onChange={handleChange}
              className="tw-p-2 tw-bg-[#202020] tw-mt-2 tw-mb-6 tw-w-full tw-rounded-md"
            >
              <option value="Protega Product Protection">Protega Product Protection</option>
              <option value="Protega Shipping Protection">Protega Shipping Protection</option>
              <option value="Other Technical Support">Other Technical Support</option>
            </select>
          </div>

          <div data-aos="fade-up">
            <label htmlFor="message">How can we help you?</label>
            <textarea
              id="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Enter your query"
              className="tw-p-2 tw-h-40 tw-bg-[#202020] tw-mt-2 tw-mb-6 tw-w-full tw-rounded-md tw-resize-none"
              required
            />
          </div>

          <button
            data-aos="fade-up"
            type="submit"
            disabled={loading}
            className="tw-p-2 tw-mt-2 tw-mb-6 tw-transition-all tw-duration-300 tw-w-full tw-rounded-md tw-border tw-border-[#00C5FB] hover:tw-bg-[#00C5FB] hover:tw-text-white tw-text-[#00C5FB]"
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </main>
      <Footer />
    </>
  );
};

export default ContactForm;
